import * as React from "react";
import { AutoCompleteInput, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';
import { WidgetDesignerPillInput } from "../pill-input/PillInput";

export function PillInputProperty(title: string, props: string): IUIPropertyDefinition<string> {
    return {
        defaults: props,
        render: (props) => {

            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    {/* <Label>{title}</Label> */}
                    <WidgetDesignerPillInput
                        contextData={props.contextData}
                        value={props.uiProps || ''}
                        onChange={s => props.onChange(s)}
                        className={'widget-designer-pill-input'}
                    />
                </div>
            </div>;
        }
    };
}